import { COLORS } from '@btime/constants'
import React from 'react'

import { Title } from '../../../components/presentation/Text'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  return (
    <>
      <Title size="h3" color={COLORS.dark3} noWrap>
        Plano de ação
      </Title>
      <Separator weight={2} />
    </>
  )
}

export default PageHeader
